
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/website",
      function () {
        return require("private-next-pages/settings/website.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/website"])
      });
    }
  